import React, { Component } from 'react';
import './index.scss';
import $ from 'jquery';
import 'fullpage.js/dist/jquery.fullpage.js';
const official_link = "https://comingout.simpleinfo.cc";
const encoded_link = encodeURIComponent(official_link);
const shareIcons = [
  {
    imgPath: '/content-img/icon-fb.svg',
    linkTo: `https://www.facebook.com/sharer/sharer.php?u=${encoded_link}`
  },
  {
    imgPath: '/content-img/icon-g+.svg',
    linkTo: `https://plus.google.com/share?url=${encoded_link}`
  },
  {
    imgPath: '/content-img/icon-twitter.svg',
    linkTo: `https://twitter.com/share?url=${encoded_link}` + '&text=' + "Comingout｜出櫃那件「小事」"
  }
];

const staticSidebarLinks = [
  {
    text: '想說卻還沒說的還很多',
    iconPath: '/content-img/icon-sidebar-speakout.svg',
    scrollToAnchor: 'post-section'
  },
  // {
  //   text: '出櫃找我',
  //   iconPath: '/content-img/icon-sidebar-mail.svg',
  //   linkTo: '#'
  // },
  {
    text: '關於我們',
    iconPath: '/content-img/icon-sidebar-about.svg',
    scrollToAnchor: 'footer'
  },

]


class Sidebar extends Component {
  handleToggleHamburger = () => {
    this.props.closeSidebar()
  }

  scrollTo = (anchor) => {
    this.props.onToggleHamburger();
    this.props.closeSidebar();
    $.fn.fullpage.moveTo(anchor);
  }

  render() {
    const { show, homepage } = this.props;
    return (
      <div className={`sidebar-menu ${show ? '-active' : ''}`} id="sidebar">
        <img className="toggle" src="/content-img/icon-sidebar-toggle.svg" alt="" onClick={this.handleToggleHamburger}/>
        <ul className="links">
          <ListLink text="出櫃小遊戲" iconPath="/content-img/icon-sidebar-support.svg" scrollTo={() => this.scrollTo('game')}/>
          {
            homepage.chapters &&
            homepage.chapters.length > 0 &&
            homepage.chapters.map((chapter, i) => {
              return (
                <ListLink text={`0${i+1}.${chapter.name}`} iconPath="/content-img/icon-sidebar-chapter.svg" key={i} scrollTo={() => this.scrollTo(`${i + 1}.1`)}/>
              )
            })
          }
          {
            staticSidebarLinks.map((l, i) => {
              return (
                l.scrollToAnchor ?
                <ListLink text={l.text} iconPath={l.iconPath} key={i} scrollTo={() => this.scrollTo(l.scrollToAnchor)}/>
                :
                <ListLink text={l.text} iconPath={l.iconPath} key={i} onClick={() => this.handleToggleHamburger}/>
              )
            })
          }
          <ListLink text='贊助我們' iconPath='/content-img/icon-sidebar-support-2.svg' linkTo={homepage && homepage.sponsor_link}/>
        </ul>
        <div className="shares">
          <ul className="icons">
          {
            shareIcons.map((icon, i) => {
              return (
                <li className="icon" key={i}>
                  <a href={icon.linkTo} target="_blank"><img src={icon.imgPath} alt=""/></a>
                </li>
              )
            })
          }
          </ul>
        </div>
      </div>
    );
  }
}

class ListLink extends Component {

  render() {
    const { text, iconPath, iconNum, active, linkTo, scrollToAnchor } = this.props;
    return (
      <li className={`link ${active ? '-active' : ''}`}>
        <a href={linkTo} onClick={this.props.scrollTo || null} target="_blank">
          {
            iconPath ?
            <img className="icon -img" src={iconPath} alt={text}/>
            :
            <span className="icon -text">{iconNum}</span>
          }

          <span className="text">{text}</span>
        </a>
      </li>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/pure.js